import React, { memo } from "react";

interface IProps {
  size?: number;
}

const FilterIcon: React.FC<IProps> = memo(({ size = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M8.75321 20.5C8.39995 20.5 8.10384 20.3802 7.86487 20.1406C7.6259 19.901 7.50642 19.6042 7.50642 19.25V11.75L0.275027 2.5C-0.0366703 2.08333 -0.083425 1.64583 0.134763 1.1875C0.352952 0.729167 0.732184 0.5 1.27246 0.5H18.7275C19.2678 0.5 19.647 0.729167 19.8652 1.1875C20.0834 1.64583 20.0367 2.08333 19.725 2.5L12.4936 11.75V16.75C12.4936 17.8488 10 20.5 8.75321 20.5Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { FilterIcon };
